import { QuestionConfig, CustomQuestionConfig, ConfigurableQuestionnaireKey } from "./models";

export const LOAD_QUESTIONNAIRE_CONFIG = "LOAD_QUESTIONNAIRE_CONFIG";
export const SAVE_QUESTIONNAIRE_CONFIG = "SAVE_QUESTIONNAIRE_CONFIG";
export const CREATE_ADDITIONAL_QUESTION = "CREATE_ADDITIONAL_QUESTION";
export const REMOVE_ADDITIONAL_QUESTION = "REMOVE_ADDITIONAL_QUESTION";
export const LOAD_TERMS_AND_CONDITIONS_OF_USE_DEFAULT_TEXT = "LOAD_TERMS_AND_CONDITIONS_OF_USE_DEFAULT_TEXT";

export const QUESTIONNAIRE_CONFIG_LOADED = "QUESTIONNAIRE_CONFIG_LOADED";

export const QUESTIONNAIRE_CONFIG_SAVED = "QUESTIONNAIRE_CONFIG_SAVED";

export const QUESTIONNAIRE_CONFIG_ADDITIONAL_QUESTION_ADDED = "QUESTIONNAIRE_CONFIG_ADDITIONAL_QUESTION_ADDED";
export const QUESTIONNAIRE_CONFIG_ADDITIONAL_QUESTION_REMOVED = "QUESTIONNAIRE_CONFIG_ADDITIONAL_QUESTION_REMOVED";

export const TERMS_AND_CONDITIONS_OF_USE_DEFAULT_TEXT_LOADED = "TERMS_AND_CONDITIONS_OF_USE_DEFAULT_TEXT_LOADED";

interface QuestionnaireConfigLoadedPayload {
    questionnaireType: string;
    questions: QuestionConfig[];
    additionalQuestions: CustomQuestionConfig[];
}

interface TermsAndConditionsOfUseDefaultTextLoadedPayload {
    defaultText: string;
}

export interface QuestionnaireConfigAdditionalQuestionAddedPayload {
    questionnaireType: ConfigurableQuestionnaireKey;
    questionAdded: CustomQuestionConfig;
}

export interface QuestionnaireConfigAdditionalQuestionRemovedPayload {
    questionnaireType: string;
    questionId: string;
}

export type QuestionnaireConfigLoaded = { payload: QuestionnaireConfigLoadedPayload; type: typeof QUESTIONNAIRE_CONFIG_LOADED };
export type QuestionnaireConfigSaved = { payload: QuestionnaireConfigLoadedPayload; type: typeof QUESTIONNAIRE_CONFIG_SAVED };
export type QuestionnaireConfigAdditionalQuestionAdded = {
    payload: QuestionnaireConfigAdditionalQuestionAddedPayload;
    type: typeof QUESTIONNAIRE_CONFIG_ADDITIONAL_QUESTION_ADDED;
};
export type QuestionnaireConfigAdditionalQuestionRemoved = {
    payload: QuestionnaireConfigAdditionalQuestionRemovedPayload;
    type: typeof QUESTIONNAIRE_CONFIG_ADDITIONAL_QUESTION_REMOVED;
};

export type QuestionnaireConfigAction =
    QuestionnaireConfigLoaded |
    QuestionnaireConfigSaved |
    QuestionnaireConfigAdditionalQuestionAdded |
    QuestionnaireConfigAdditionalQuestionRemoved;

export const questionnaireConfigLoaded = (payload: QuestionnaireConfigLoadedPayload) => ({
    type: QUESTIONNAIRE_CONFIG_LOADED,
    payload
});

export const questionnaireConfigSaved = (payload: QuestionnaireConfigLoadedPayload) => ({
    type: QUESTIONNAIRE_CONFIG_SAVED,
    payload
});

export const questionnaireConfigCustomQuestionAdded = (payload: QuestionnaireConfigAdditionalQuestionAdded) => ({
    type: QUESTIONNAIRE_CONFIG_ADDITIONAL_QUESTION_ADDED,
    payload
});

export const termsAndConditionsOfUseDefaultTextLoaded = (payload: TermsAndConditionsOfUseDefaultTextLoadedPayload) => ({
    type: TERMS_AND_CONDITIONS_OF_USE_DEFAULT_TEXT_LOADED,
    payload
});
